/**
 * Detect and parse manual retweets (tweets starting with "RT @username:")
 */

// Interface for tweet-like objects with referencedTweets
interface TweetWithReferences {
  referencedTweets?: Array<{
    type: string;
    id?: string;
  }>;
  text: string;
}

export interface ManualRetweetInfo {
  fullText: string;
  isManualRetweet: boolean;
  originalText?: string;
  originalUsername?: string;
}

/**
 * Detects if a tweet is a manual retweet (starts with "RT @username:")
 * and extracts the original username and text
 */
export function detectManualRetweet(text: string): ManualRetweetInfo {
  // Match "RT @username:" pattern at the start of the tweet
  const match = text.match(MANUAL_RT_PATTERN);

  if (match) {
    const info: ManualRetweetInfo = {
      isManualRetweet: true,
      fullText: text,
    };
    if (match[1]) {
      info.originalUsername = match[1];
    }
    const extractedText = match[2];
    if (typeof extractedText === 'string') {
      info.originalText = extractedText;
    }
    return info;
  }

  return {
    isManualRetweet: false,
    fullText: text,
  };
}

/**
 * Check if we should treat this as a retweet for display purposes
 */
export function shouldDisplayAsRetweet(tweet: TweetWithReferences): boolean {
  // Check for API retweets
  if (tweet.referencedTweets?.some((reference) => reference.type === 'retweeted')) {
    return true;
  }

  // Check for manual retweets
  const { isManualRetweet } = detectManualRetweet(tweet.text);
  return isManualRetweet;
}
const MANUAL_RT_PATTERN = /^RT\s+@([a-zA-Z0-9_]+):\s*(.*)$/s;
